import { call, put } from 'redux-saga/effects';
import { ActionType } from 'deox';

import { handleAPIError } from '@/utils/handle-api-error';
import { getLicensePriceAction } from '@/redux/actions/company';
import { getLicensePrice, TLicensePriceResponse } from '@/services/api/company';

export function* getLicensePriceSaga(action: ActionType<typeof getLicensePriceAction.request>): Generator {
  const { successCallback, failedCallback } = action.payload;
  try {
    const response = yield call(getLicensePrice);
    const priceResponse: TLicensePriceResponse = response as TLicensePriceResponse;
    yield put(getLicensePriceAction.success(priceResponse));
    successCallback?.(priceResponse);
  } catch (err) {
    handleAPIError(err, 'Error.getLicensePriceError');
    yield put(getLicensePriceAction.failure(err));
    failedCallback?.(err);
  }
}
